import { render, staticRenderFns } from "./PatientAgreementsHistoryModal.vue?vue&type=template&id=57585709&scoped=true&"
import script from "./PatientAgreementsHistoryModal.vue?vue&type=script&lang=js&"
export * from "./PatientAgreementsHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./PatientAgreementsHistoryModal.vue?vue&type=style&index=0&id=57585709&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57585709",
  null
  
)

component.options.__file = "PatientAgreementsHistoryModal.vue"
export default component.exports